module.exports = function _isPlaceholder(a) {
  return a != null &&
         typeof a === 'object' &&
         a['@@functional/placeholder'] === true;
};



//////////////////
// WEBPACK FOOTER
// ./~/coact/~/ramda/src/internal/_isPlaceholder.js
// module id = 1366
// module chunks = 0